import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile, isTablet, isWideScreen } from "../../../@css-style";

export const ElBanner = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 2em 0;
  background-color: transparent;
  background: linear-gradient(180deg, #e9f5ff 700%, rgba(229, 239, 255, 0.26) 83.7%, rgba(229, 239, 255, 0) 700%);

  ${isMobile} {
    padding: 4em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElDetails = styled.p`
  /* width: 100%; */
  font-family: Inter;
  text-align: left;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;

  color: var(--theme-main-flat-dark-color);
  * {
    font-family: Inter;
    text-align: left;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
  ${isMobile} {
    font-size: 16px !important;
    * {
      font-size: 16px !important;
    }
  }
  strong {
    font-weight: 700;
  }
  ol {
    list-style: decimal;
    padding-left: revert;
  }
  ul {
    list-style: initial;
    padding-left: revert;
  }
`;

export const ElContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  align-items: center;
  position: relative;
  z-index: 2;
  /* justify-content: center; */
  ${isTablet} {
    width: 100% !important;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    flex-direction: column;
    flex: none !important;
    ${ElDetails} {
      align-items: flex-start;
      justify-content: flex-start;
      text-align: left;
    }
  }
`;

export const ElContentParent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  align-items: flex-start;
  flex: 1;
  position: relative;
  z-index: 2;
  ${ElContent} {
    flex: 1;
  }
`;

export const elGapBanner = css`
  gap: 20px;
`;

export const elGapTitle = css`
  gap: 10px;
`;

export const ElBannerImageCircle = styled.img`
  max-width: 100%;
  height: auto;
  position: absolute;
  min-height: 10px;
  width: 500px !important;
  rotate: 180deg !important;
  bottom: -30%;
  left: -9%;
  top: auto;
  opacity: 0.6;
`;

export const ElBannerImageInfinite = styled.img`
  max-width: 100%;
  rotate: 180deg !important;
  height: auto;
  position: absolute;
  width: 500px !important;
  right: 0;
  top: 39%;
  opacity: 0.6;
`;
